import * as z from "zod";

export const CustomerAccountsStorefrontDisplayFlatTeamSettingsSchema = z.object(
  {
    "customerAccounts/saveForLaterPanel/enabled": z.boolean().nullish(),
    "customerAccounts/saveForLaterPanel/title": z.string().nullish(),
    "customerAccounts/saveForLaterPanel/message": z.string().nullish(),
    "customerAccounts/saveForLaterPanel/numViewedProductsUntilPanelOpen": z
      .number()
      .nullish(),
    "customerAccounts/saveForLaterPanel/anchorLocation": z.string().nullish(),
    "customerAccounts/nativeAccounts/overrideAccountLinks": z
      .boolean()
      .nullish(),
    "customerAccounts/nativeAccounts/redirectFromAccountsPages": z
      .boolean()
      .nullish(),
  },
);
